
const selectJump =
    [{ label: "本页", value: "self" }, { label: "打开新页面", value: "new" }, { label: "弹出", value: "pop" },{ label: "传值", value: "setValue" },];
    // [{ label: "本页", value: "self" }, { label: "打开新页面", value: "new" }, { label: "弹出", value: "pop" },{ label: "跳转内部链接", value: "innerout" },{ label: "跳转外部链接", value: "newout" },{ label: "传值", value: "setValue" },];

const selectOperation = [{ value: 'close', label: '关闭返回' }, { value: 'return', label: '留在原页' }];

const selectSearchType = [{ value: 'like', label: '模糊查询' }, { value: '=', label: '精确匹配' }];
const selectMode = [{ value: 'default', label: '单选模式' }, { value: 'multiple', label: '多选模式' }]
const selectSize = [{ value: 'large', label: '大' }, { value: 'default', label: '中' }, { value: 'small', label: '小' }];
const selectSize2 = [{ value: 'default', label: '大' }, { value: 'middle', label: '中' }, { value: 'small', label: '小' }]
const selectTextSeat = [{ value: 'left', label: '左' }, { value: 'top', label: '上' }];
const selectThemeSize = [{ value: 'primary', label: '主' }, { value: 'default', label: '默认' }, { value: 'dashed', label: '虚线' }, { value: 'danger', label: '危险' }];
const selectTitleSize = [{ value: 'h1', label: 'h1' }, { value: 'h2', label: 'h2' }, { value: 'h3', label: 'h3' }, { value: 'h4', label: 'h4' }, { value: 'h5', label: 'h5' }, { value: 'h6', label: 'h6' },{ value: null, label: '无' }];
const selectTextSize = [{ value: 'sm', label: '小' }, { value: 'md', label: '中' }, { value: 'lg', label: '大' }];
const selectTextStyle = [{ value: 'small', label: '小' }, { value: 'strong', label: '粗' }, { value: 'em', label: '斜' }];
const selectTextAlign = [{ value: 'left', label: '左' }, { value: 'center', label: '中' }, { value: 'right', label: '右' }];
const selectTextColor = [{ value: 'red', label: '薄暮' }, { value: 'volcano', label: '火山' }, { value: 'orange', label: '日暮' }, { value: 'gold', label: '金盏花' }, { value: 'yellow', label: '日出' }, { value: 'lime', label: '青柠' },
{ value: 'green', label: ' 绿' }, { value: 'cyan', label: '青' }, { value: 'blue', label: '蓝' }, { value: 'geekblue', label: '极客蓝' }, { value: 'purple', label: '酱紫' }, { value: 'magenta', label: '法式洋红' }];
const selectTextFormat = [{ value: 'nowrap', label: '不换行' }, { value: 'truncate', label: '截断省略' }, { value: 'lowercase', label: '小写' }, { value: 'uppercase', label: '大写' }, { value: 'capitalize', label: '首字母大写' }, { value: 'deleted', label: '删除' }];
const selectDriverType = [{ value: 'horizontal', label: '水平' }, { value: 'vertical', label: '垂直' }];
const selectDriverOrientation = [{ value: '', label: '居中' }, { value: 'left', label: '左' }, { value: 'right', label: '右' }];
const importModel = [{ value: '0', label: '插入' }, { value: '1', label: '更新' }, { value: '2', label: '插入+更新' }];

const eventType1 = [
    { value: 'workflow', label: '工作流迁移' },
];
const eventTypeInput = [
    { value: 'sendSimpleEvent', label: '发送简单通知' },
    // { value: 'sendSimpleEvent2', label: '发送简单通知2' },
];
const eventType2 = [
    { value: 'workflow', label: '工作流迁移' },
    { value: 'form_reset', label: '表单重置' },
    { value: 'dialog_close', label: '关闭弹框' },
    { value: 'sendSimpleEvent', label: '发送简单通知' },
];
const fileType = [
    { value: 'image/*', label: '图片' },
    { value: 'audio/*', label: '音频' },
    { value: 'video/*', label: '视频' },
    { value: '.pdf', label: '.pdf' },
    { value: '.doc', label: '.doc' },
    { value: '.docx', label: '.docx' },
    { value: '.xls', label: '.xls' },
    { value: '.xlsx', label: '.xlsx' },
];
const fileUploadType = [
    { value: '0', label: '文件' },
    { value: '1', label: 'base64' }
];

const selectValidators = [
    { value: 'required', label: '必需' },
    { value: 'maxlength', label: '最大长度' },
    { value: 'minlength', label: '最小长度' },
    { value: 'min', label: '最小值' },
    { value: 'max', label: '最大值' },
    { value: 'email', label: '邮箱' },
    { value: 'pattern', label: '正则' },
    { value: 'equal', label: '两字段相等' },

];

const Layout1 = [1, 7, 1, 13, 0, 2];

const formSetText = {
    required: { label: "必需", param1Label: "必需 :" },
    minlength: { label: "最小长度", param1Label: "最小长度 :" },
    maxlength: { label: "最大长度", param1Label: "最大长度 :" },
    min: { label: "最小值", param1Label: "最小值 :" },
    max: { label: "最大值", param1Label: "最大值 :" },
    email: { label: "邮箱", param1Label: "邮箱 :" },
    pattern: { label: "正则", param1Label: "正则表达式 :" },
    equal: { label: "两字段相等", param1Label: "另一个字段 :" },
};

const HorizontalDate = [
    { value: "start", label: "左聚集" },
    { value: "center", label: "中间聚集" },
    { value: "end", label: "右聚集" },
    { value: "space-between", label: "等宽" },
    { value: "space-around", label: "充满" },
    { value: "", label: "无" },
]
const VerticalDate = [
    { value: "top", label: "顶部对齐" },
    { value: "middle", label: "中间对齐" },
    { value: "end", label: "右聚集" },
    { value: "bottom", label: "底部对齐" },
    { value: "", label: "无" },
]
const iconTheme =
    [{ label: "fill", value: "fill" }, { label: "outline", value: "outline" }, { label: "twotone", value: "twotone" }, { label: "无", value: "" }];
const iconTheme2 =
    [{ label: "fill", value: "fill" }, { label: "outline", value: "outline" }, { label: "twotone", value: "twotone" }];


const dataMode = [
    { value: "date", label: "日期选择" },
    { value: "month", label: "月份选择" },
    { value: "year", label: "年份选择" },
    { value: "range", label: "范围选择" },
    { value: "week", label: "周选择" },
]
const disabledHours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]
const disabledMinutes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29,
    30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59]
export {
    fileType,fileUploadType,
    disabledMinutes, disabledHours, selectThemeSize,eventType1,eventType2,eventTypeInput,
    HorizontalDate, VerticalDate, selectSize2, selectMode, iconTheme, dataMode,
    Layout1, selectJump, selectSize, selectOperation, selectSearchType, selectTextSeat,
    selectValidators, selectTitleSize, formSetText, selectTextSize, selectTextStyle, selectTextAlign,
    selectTextColor, selectTextFormat, iconTheme2, selectDriverType, selectDriverOrientation,importModel
};
